import { genMuiThemes } from 'clnt-common';

const ltp    = '#e6e5f5';    // light color with red tint - nav bar bg color
const lts    = '#9c27b0';    // button bg in light mode (darker purple) - secondary / also used in the manifest.webmanifest
const ltpnl  = '#e6e5f5';    // light color with darker red tint for panel - 22 biggest... section bg color
const ltcpnl = '#e6e5f0';    // light content panel -  (The same is used in manifest.webmanifest)

const dkp    = '#121212';    // '#121212',
const dks    = '#a257af';    // button bg in dark mode (lighter purple) - secondary
const dkpnl  = '#121212';    // compliment to ltpnl
const dkcpnl = '#121210';    // dark content panel

const options = {
  fontHeader :      'Albra',
  fontText :        'Poppins',

  primaryLight:     ltp,   //'#e3e2f9', //'#f1ecf7', //'#ededed',
  secondaryLight:   dks,   //'#9c27b0',
  panelBgLight:     ltpnl,   //'#ffffff',
  backpanelBgLight: ltp,   //'#484848',
  contentpanelBgLight: ltcpnl,

  primaryDark:      dkp,   //'#121212',
  secondaryDark:    lts,   //'#ce93d8',
  panelBgDark:      dkpnl,   //'#121212', //3a3030',
  backpanelBgDark:  dkp,   //'#cfcfcf',
  contentpanelBgDark:  dkcpnl,

  pagePadding : 1,
  pageGap : 0,

  // For use within pages.ts (rendered via PageContentFormat.jsx)
  // 5 sets of areas.
  areaLight: [{ panel: '', border: '#cccccc' },  // about
              { panel: '', border: '#3845f3' },  // service:matrix
              { panel: '#e8eafb', border: '' },  // service:chat
              { panel: '#f6f1f1', border: '#0d2389' },  // service: *
              { panel: '', border: '' }],  
  areaDark:  [{ panel: '', border: '' },  
              { panel: '', border: '' },  
              { panel: '', border: '' },  
              { panel: '', border: '' },  
              { panel: '', border: '' }]  
};

export { themes };
let themes = genMuiThemes(options);



